<script>
    // import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import orders from "../stores/orders";
    // import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate, scrollTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import PdfModal from "./PdfModal.svelte";

    let printItems = null;

    const pageHeaderControls = [
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'date_at', title: 'ΗΜΕΡΟΜΗΝΙΑ', sortable: true, sort_way: 'DESC'},
        {key: 'code', title: 'ΕΝΤΟΛΗ', sortable: true},
        {key: 'total_samples', title: 'ΔΕΙΓΜ.', class: 'hidden-xs'},
    ];

    const itemsPerPage = [20, 50, 100, 500];

    const load = (loader = null) => {
        const onSuccess = result => {

            $orders.list = result.orders;
            $orders.total = result.total;
            $orders.total_samples = result.total_samples;
            console.log("orders", $orders.list);
        }

        const onFailure = err => {
        };

        if (loader == null) {
            loader = LOADER.PAGE;
        }

        $orders.search.offset = ($orders.page - 1) * $orders.search.limit;
        if ($orders.search.client_term || $orders.search.code) {
            $orders.search.client_id = null;
        }

        R.handle(R.order.index, $orders.search, onSuccess, onFailure, loader);
    }

    // const search = () => {
    //     $orders.page = 1;
    //     load();
    // }

    // const clearSearch = () => {
    //     orders.clearSearch();
    //     load();
    // }

    // const onSearchChange = () => {
    //     load();
    // }

    const onColumnSort = ({detail}) => {
        $orders.search.sort_field = detail.key;
        $orders.search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        $orders.page = detail;
        load();
        scrollTo('listing-top', -50);
    }


    const initialize = () => {
        // get search criteria from url parameters
        if (window.location.search) {
            let arr = window.location.search.replace("?", "").split("&");
            arr.map(item => {
                let param = item.split("=");
                if (param[0] === 'client_id') {
                    $orders.search.client_id = param[1];
                }
            });
        }

        if (!$orders.list) {
            $orders.page = 1;
            $orders.search.limit = itemsPerPage[0];

            load();
        } else if ($orders.changed) {
            // order data changed from OrderEdit component
            load(LOADER.NONE);
            $orders.changed = false;
        }

        if ($orders.scrollY != null) {
            // set window scroll position to last edited transfer
            setTimeout(function () {
                window.scrollTo({top: $orders.scrollY});
                $orders.scrollY = null;
            }, 50);

        }
    }

    const toggleOrder = order => {
        $orders.selectedId = order.id;
        order.expanded = !order.expanded;
        $orders.list = $orders.list;
    }

    const onSelectAll = order => {
        order.samples.map(sample => {
            sample.selected = true;
        });
        $orders.list = $orders.list;
    }

    const onClearAll = order => {
        order.samples.map(sample => {
            sample.selected = false;
        });
        $orders.list = $orders.list;
    }

    const onPrint = order => {
        let samples = [];
        order.samples.map(sample => {
            if (sample.selected) {
                samples.push(sample.id);
            }
        });

        if (!samples.length) {
            Notifier.showError("Δεν έχετε επιλέξει δείγματα για εκτύπωση!");
            return;
        }

        printItems = {
            object: 'samples',
            samples: samples
        };
    }

    const closePrint = () => {
        printItems = null;
    }

    initialize();
</script>

<PageHeader title="{ $user.company }" controls={ pageHeaderControls } on:reload={ load }/>

<!--<div class="panel panel-simple p-2 mb-5">-->
<!--    <div class="row">-->
<!--        <div class="col-xl-2 col-lg-2 col-md-3 col-6">-->
<!--            <div class="form-group-sm form-group-md">-->
<!--                <div class="form-item">-->
<!--                    <div class="form-item-info top">από</div>-->
<!--                    <input type="date" class="form-control" bind:value="{ $orders.search.date_from }"-->
<!--                           on:change={ search }>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-xl-2 col-lg-2 col-md-3 col-6">-->
<!--            <div class="form-group-sm form-group-md">-->
<!--                <div class="form-item">-->
<!--                    <div class="form-item-info top">έως</div>-->
<!--                    <input type="date" class="form-control" bind:value="{ $orders.search.date_to }"-->
<!--                           on:change={ search }>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-xl-1 col-lg-2 col-md-6">-->
<!--            <div class="form-group-sm form-group-md">-->
<!--                <input type="text" class="form-control" bind:value="{ $orders.search.code }" on:change={ search }-->
<!--                       placeholder="κωδ. εντολής">-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-xl-1 col-lg-2 col-md-6">-->
<!--            <div class="form-group-sm form-group-md">-->
<!--                <input type="text" class="form-control" bind:value="{ $orders.search.sample_code }" on:change={ search }-->
<!--                       placeholder="κωδ. δείγματος">-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-xl-4 col-lg-4 col-md-6">-->
<!--        </div>-->
<!--        <div class="col-xl-1 col-lg-1 col-md-3 col-6">-->
<!--            <button class="btn btn-default btn-block text-truncate" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>-->
<!--        </div>-->
<!--        <div class="col-xl-1 col-lg-2 col-md-3 col-6">-->
<!--            <button class="btn btn-outline btn-block" on:click={ search }>ΕΥΡΕΣΗ</button>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->

<!--<div class="row align-items-center mb-4" id="listing-top">-->
<!--    <div class="col-xl-2 col-lg-3 col-md-4 col-7">-->
<!--        <select class="form-select form-select-sm" bind:value="{ $orders.search.limit }" on:change="{ search }">-->
<!--            {#each itemsPerPage as item}-->
<!--                <option value="{ item }">εμφάνιση { item } / σελίδα</option>-->
<!--            {/each}-->
<!--        </select>-->
<!--    </div>-->
<!--    {#if $orders.list && $orders.list.length}-->
<!--        <div class="col-xl-10 col-lg-9 col-md-8 col-5">-->
<!--            <span class="listing-info">Εντολές: <strong>{ $orders.total }</strong></span>-->
<!--            <span class="listing-info hidden-xs">Δείγματα: <strong>{ $orders.total_samples }</strong></span>-->
<!--            <span class="listing-info hidden-xs">Σελίδα: <strong>{ $orders.page }</strong></span>-->
<!--        </div>-->
<!--    {/if}-->
<!--</div>-->

{#if $orders.list}
    {#if $orders.list.length}
        <table class="table table-list orders-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each $orders.list as item}
                <tr class="row-hover pointer" class:row-selected="{ $orders.selectedId === item.id }"
                    on:click={ () => toggleOrder(item) }>
                    <td class="date-column">
                        <div class="d-flex align-items-center">
                            <div>
                                {#if item.expanded}
                                    <AppIcon icon="chevron-down" size="18" strokeWidth="3"/>
                                {:else}
                                    <AppIcon icon="chevron-right" size="18" strokeWidth="3"/>
                                {/if}
                            </div>
                            { formatDate(item.date_at, 'd-m-y') }
                        </div>
                    </td>
                    <td class="text-gray">
                        { item.code }
                    </td>
                    <td class="samples-column text-gray text-center hidden-xs">
                        { item.samples.length }
                    </td>
                </tr>
                {#if item.expanded}
                    <tr>
                        <td colspan="{ tableColumns.length }" class="container-column">
                            <div class="panel-simple p-2 mb-2">
                                <div class="order-panel text-gray">
                                    Επιλέξτε μία ή περισσότερες αναλύσεις για εκτύπωση
                                    <div class="order-controls">
                                        <button class="btn btn-outline btn-sm" title="επιλογή όλων"
                                                on:click={ () => onSelectAll(item) }>
                                            <AppIcon icon="square-check-solid" strokeWidth="2"/>
                                        </button>
                                        <button class="btn btn-outline btn-sm" title="καθαρισμός επιλεγμένων"
                                                on:click={ () => onClearAll(item) }>
                                            <AppIcon icon="square-solid"/>
                                        </button>
                                        <button class="btn btn-outline btn-sm" title="εκτύπωση επιλεγμένων"
                                                on:click={ () => onPrint(item) }>
                                            <AppIcon icon="print"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <table class="table-list table-sm">
                                <thead>
                                <tr>
                                    <th>Κωδικός</th>
                                    <th>Είδος</th>
                                    <th class="hidden-xs">Έκδ.</th>
                                </tr>
                                </thead>
                                <tbody>
                                {#each item.samples as sample}
                                    <tr>
                                        <td>
                                            <Checkbox label="2003{ sample.code }" bind:checked="{ sample.selected }"/>
                                        </td>
                                        <td>
                                            {#if sample.characterization }
                                                { sample.characterization } /
                                            {/if}
                                            { sample.type }
                                        </td>
                                        <td class="text-center hidden-xs">{ sample.edition }</td>
                                    </tr>
                                {/each}
                                <tr>
                                    <td colspan="3">
                                        <button class="btn btn-primary btn-sm btn-block py-1"
                                                on:click={ () => onPrint(item) }>Εκτύπωση
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                {/if}
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ $orders.search.limit }" totalItems="{ $orders.total }"
                    page="{ $orders.page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel panel-simple panel-pad">
            Δεν βρέθηκαν αναλύσεις.
        </div>
    {/if}

    {#if printItems}
        <PdfModal {printItems} closeCallback="{ closePrint }"/>
    {/if}
{/if}

<style>
    .orders-list .samples-column {
        width: 80px;
    }

    .order-panel {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    @media (max-width: 576px) {
        .order-panel {
            display: block;
        }

        .order-controls {
            text-align: right;
            padding-top: 10px;
            border-top: 1px solid #dce8ef;
            margin-top: 10px;
        }
    }
</style>